import React from 'react';

const QuickKeyFunctionTitle = ({ record }) => {
	return <span>QuickKeyFunction {record ? `"${record.name}"` : ''}</span>;
};
export default QuickKeyFunctionTitle;
